var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfilePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#E3E3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0029 50.639C54.9964 50.639 61.4764 44.159 61.4764 36.1655C61.4764 28.1719 54.9964 21.6919 47.0029 21.6919C39.0093 21.6919 32.5293 28.1719 32.5293 36.1655C32.5293 44.159 39.0093 50.639 47.0029 50.639Z",
    fill: "#CD566C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9997 45.6921C29.8236 45.6921 21.0339 51.5642 16.8091 60.1163C16.7301 60.3591 16.5959 60.5591 16.4448 60.7101C16.1269 61.0281 15.7677 61.102 15.6787 61.1198C15.6057 61.1344 15.5435 61.1412 15.4988 61.1447C15.4754 61.1465 15.4541 61.1475 15.4353 61.1482L15.4082 61.1489L15.3956 61.149L15.3896 61.1491L15.3852 61.1491C15.3844 61.1491 15.3837 61.1491 15.3837 59.659L15.3837 61.1491C14.5608 61.1491 13.8936 60.482 13.8936 59.659C13.8936 59.6567 13.8936 59.6543 13.8936 59.6519C13.8916 59.4273 13.9404 59.2005 14.0428 58.9891C18.7125 49.3566 28.5686 42.7119 39.9997 42.7119C51.4307 42.7119 61.2868 49.3566 65.9565 58.9891C66.0547 59.1917 66.1057 59.414 66.1057 59.6391V59.6585C66.1057 60.4815 65.4386 61.1491 64.6157 61.1491C63.9688 61.1491 63.4182 60.7369 63.2122 60.1609C58.996 51.5846 50.1935 45.6921 39.9997 45.6921ZM14.33 60.6928C14.3168 60.6796 14.293 60.6556 14.2631 60.6213C14.2845 60.6457 14.3068 60.6696 14.33 60.6928Z",
    fill: "#060606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9999 20.4801C33.8607 20.4801 28.884 25.4569 28.884 31.596C28.884 37.7352 33.8607 42.712 39.9999 42.712C46.1391 42.712 51.1158 37.7352 51.1158 31.596C51.1158 25.4569 46.1391 20.4801 39.9999 20.4801ZM25.9038 31.596C25.9038 23.811 32.2148 17.4999 39.9999 17.4999C47.785 17.4999 54.096 23.811 54.096 31.596C54.096 39.3811 47.7849 45.6921 39.9999 45.6921C32.2148 45.6921 25.9038 39.3811 25.9038 31.596Z",
    fill: "#060606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9959 15.4061C23.8414 10.1742 31.5528 6.99982 39.9997 6.99982C58.2267 6.99982 72.9998 21.773 72.9998 40C72.9998 58.227 58.2267 73.0001 39.9997 73.0001C21.7727 73.0001 6.99951 58.227 6.99951 40C6.99951 33.5311 8.86201 27.4952 12.0769 22.3971C12.5159 21.701 13.436 21.4926 14.1321 21.9316C14.8282 22.3705 15.0366 23.2907 14.5977 23.9868C11.6735 28.6238 9.97966 34.1111 9.97966 40C9.97966 56.5811 23.4186 70.02 39.9997 70.02C56.5808 70.02 70.0197 56.5811 70.0197 40C70.0197 23.4189 56.5808 9.97996 39.9997 9.97996C32.3139 9.97996 25.3035 12.8652 19.9834 17.6267C19.3702 18.1756 18.4282 18.1234 17.8793 17.5102C17.3305 16.897 17.3827 15.9549 17.9959 15.4061Z",
    fill: "#060606"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EC5569"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75.7273C79 76.1613 78.8276 76.5775 78.5207 76.8843C78.2138 77.1912 77.7976 77.3636 77.3636 77.3636H62.6364C62.2024 77.3636 61.7862 77.1912 61.4793 76.8843C61.1724 76.5775 61 76.1613 61 75.7273V66.7273C61 66.2933 61.1724 65.8771 61.4793 65.5702C61.7862 65.2633 62.2024 65.0909 62.6364 65.0909H65.9091L67.5455 62.6364H72.4545L74.0909 65.0909H77.3636C77.7976 65.0909 78.2138 65.2633 78.5207 65.5702C78.8276 65.8771 79 66.2933 79 66.7273V75.7273Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9998 74.0909C71.8073 74.0909 73.2725 72.6257 73.2725 70.8182C73.2725 69.0107 71.8073 67.5455 69.9998 67.5455C68.1923 67.5455 66.7271 69.0107 66.7271 70.8182C66.7271 72.6257 68.1923 74.0909 69.9998 74.0909Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfilePhoto);
export default __webpack_public_path__ + "static/media/icon-profile-photo.8da4b1352e60a21f09c0c61d86e202da.svg";
export { ForwardRef as ReactComponent };